import { Injectable } from '@angular/core';
import { Column, ColumnType } from '../../../../SGRE-shared/models/tableConfiguration';
import { myProfileConstants } from '../../model/my-profile-model';
import { MyProfilePage, LegalEntities, User } from '../my-profile-state';
import { UserRoles, UserRoleType } from '../../../../SGRE-shared/constants/app-constant';

@Injectable({
  providedIn: 'root'
})
export class MyProfileEffectsService {

  constructor() { }

  formatMyProfileData(data: MyProfilePage): MyProfilePage {
    const formattedData = data?.newLegalEntityPendingRoles?.length
      ? data?.newLegalEntityPendingRoles.map(item => this._mapData(item)).concat(data?.legalEntities.map(item => this._mapData(item)))
      : data?.legalEntities.map(item => this._mapData(item));
    const user: User = {
      customerEmail: data?.customerEmail,
      alternateEmail: data?.alternateEmail ? data?.alternateEmail : '-',
      customerName: data?.customerName,
      isInternal: data?.isInternal,
      emailChanged: data?.alternateEmail ? data?.alternateEmail : '-',
    }
    const updatedData: MyProfilePage = this.createTableConfiguration(user, formattedData);
    return updatedData;
  }

  _mapData(profileData: LegalEntities): LegalEntities {
    profileData.Requester = this.statusChange(profileData, UserRoles.REQUESTER);
    profileData.Purchaser = this.statusChange(profileData, UserRoles.PURCHASER);
    profileData.CustomerAdmin = this.statusChange(profileData, UserRoles.CUSTOMER_ADMIN);
    profileData.SalesRep = this.statusChange(profileData, UserRoles.SALES_REP);
    profileData.name = profileData?.name ? profileData?.name : profileData?.legalEntityName;
    profileData.uid = profileData?.uid ? profileData?.uid : profileData?.legalEntityId;
    return profileData;
  }

  statusChange(obj: LegalEntities, role: string): boolean | string {
    if (obj?.roles?.includes(role)) {
      return UserRoleType.AVAILABLE
    } else if (obj?.pendingRoles?.includes(role)) {
      return UserRoleType.PENDING
    } else {
      return false
    }
  }

  createTableConfiguration(user: User, tableData?: LegalEntities[]): MyProfilePage {
    let companyFilter = this.getFilterData(tableData, myProfileConstants.COMPANY)
    let legalEntityFilter = this.getFilterData(tableData, myProfileConstants.NAME)
    let vatIdFilter = this.getFilterData(tableData, myProfileConstants.VATID)
    let columnData = [
      {
        "name": myProfileConstants.NAME, "label": myProfileConstants.LEGAL_ENTITY_LABEL, "type": ColumnType.text,
        filter: true, filterOptions: legalEntityFilter
      },
      {
        "name": myProfileConstants.VATID, "label": myProfileConstants.VAT_ID_LABEL, "type": ColumnType.text,
        filter: true, filterOptions: vatIdFilter
      },
      {
        "name": UserRoles.REQUESTER, "label": UserRoles.REQUESTER, "type": ColumnType.tick
      },
      {
        "name": UserRoles.PURCHASER, "label": UserRoles.PURCHASER, "type": ColumnType.tick
      },
      {
        "name": myProfileConstants.CUSTOMER_ADMIN, "label": UserRoles.CUSTOMER_ADMIN, "type": ColumnType.tick
      }
    ];
    let columnDataUser = [
      {
        "name": myProfileConstants.COMPANY, "label": myProfileConstants.COMPANY_LABEL, "type": ColumnType.text,
        filter: true, filterOptions: companyFilter

      },
      {
        "name": myProfileConstants.NAME, "label": myProfileConstants.LEGAL_ENTITY_LABEL, "type": ColumnType.text,
        filter: true, filterOptions: legalEntityFilter
      },
      {
        "name": myProfileConstants.VATID, "label": myProfileConstants.VAT_ID_LABEL, "type": ColumnType.text,
        filter: true, filterOptions: vatIdFilter
      },

      {
        "name": myProfileConstants.SALES_REP, "label": UserRoles.SALES_REP, "type": ColumnType.tick
      }
    ];
    let external = columnData.map(item => new Column(item));
    let internal = columnDataUser.map(item => new Column(item));
    return { legalEntities: tableData, external, internal, user } as MyProfilePage;
  }

  getFilterData(data: LegalEntities[], filterKey: string): { [key: string]: string }[] {
    const filteredArray = data
      ?.filter((item) => item[filterKey] !== undefined)
      .map((item) => ({ [filterKey]: item[filterKey] }));
    return Array.from(new Set(filteredArray.map(item => JSON.stringify(item)))).map(item => JSON.parse(item)); // Ensure unique objects
  }

}
